import type { Metric } from 'web-vitals';
import { sendWebVitalsToGA4 } from './services/analytics';

/**
 * Report Web Vitals to Google Analytics 4
 *
 * Metrics tracked:
 * - CLS (Cumulative Layout Shift) - Visual stability
 * - FID (First Input Delay) - Interactivity
 * - FCP (First Contentful Paint) - Loading performance
 * - LCP (Largest Contentful Paint) - Loading performance
 * - TTFB (Time To First Byte) - Server response time
 */
const reportWebVitals = (onPerfEntry?: (metric: Metric) => void) => {
  // Always send to GA4
  const sendToAnalytics = (metric: Metric) => {
    sendWebVitalsToGA4({
      name: metric.name,
      value: metric.value,
      id: metric.id,
    });

    // Also call custom handler if provided
    if (onPerfEntry && onPerfEntry instanceof Function) {
      onPerfEntry(metric);
    }
  };

  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    getCLS(sendToAnalytics);
    getFID(sendToAnalytics);
    getFCP(sendToAnalytics);
    getLCP(sendToAnalytics);
    getTTFB(sendToAnalytics);
  });
};

export default reportWebVitals;
